import React from 'react';
import {useTranslation} from 'react-i18next';
import {useComputedReservationDetails} from '../../context/computedReservationDetails';
import {usePaymentSettings} from '../../hooks';
import checkIcon from 'assets/check.svg';
import calendarIcon from 'assets/icons/calendar-icon.svg';
import priceIcon from 'assets/icons/price-icon.svg';
import walletIcon from 'assets/icons/wallet-icon.svg';
import StyledIcon from 'components/acommon/StyledIcon';
import Modal from 'components/Modal';
import {
  ModalSummaryItem,
  ModalSummaryCol,
  ModalSummaryColSecond,
  ModalContent,
  ModalHeader,
  ModalTitle,
  Row,
  CheckIcon,
  ModalButton,
} from './styled';

type LocalFormatOptions = {
  year: 'numeric';
  month: 'short';
  day: 'numeric';
};
const localFormatOptions: LocalFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

type ItemProps = {
  name: string;
  icon: string;
  value: string;
};
function Item({name, icon, value}: ItemProps) {
  return (
    <ModalSummaryItem>
      <ModalSummaryCol>
        <img src={icon} alt="icon" /> <div>{' ' + name + ':'}</div>
      </ModalSummaryCol>
      <ModalSummaryColSecond>{value}</ModalSummaryColSecond>
    </ModalSummaryItem>
  );
}

type ModalProps = {
  isOpenPaidModal: boolean;
  totalPice?: string;
  housingId?: string;
  isPaymentMethod?: boolean;
  reservationId?: string;
  imageSrc?: string;
  subTitle?: string;
  handlePaidModal: () => void;
};
const PaidModal = React.memo(
  ({
    isOpenPaidModal,
    imageSrc,
    subTitle,
    isPaymentMethod,
    handlePaidModal,
    totalPice,
  }: ModalProps) => {
    const {isUsaReservation} = useComputedReservationDetails();
    const {paymentSettingsCurrencySign: currency} = usePaymentSettings();
    const {t} = useTranslation();

    const local = isUsaReservation ? 'en-US' : undefined;

    const handleModalButton = () => {
      handlePaidModal();
    };

    if (!isOpenPaidModal) return null;

    const today = new Date();
    const computedTotalPrice = (totalPice || '0.00') + currency;

    return (
      <Modal
        open={isOpenPaidModal}
        onClose={handleModalButton}
        closeOnDocumentClick
        closeOnEscape
      >
        <ModalContent>
          <ModalHeader>
            <div className="desktopImage">
              {imageSrc && <img width={110} height={110} src={imageSrc} alt="Success!" />}
            </div>
            <ModalTitle className="modalTitle">
              <CheckIcon width={32} height={32} src={checkIcon} alt="Green checkmark" />
              {t('paid')}
            </ModalTitle>
            <div className="modalMobileTitle">
              <StyledIcon name="successIcon" size="32px" color="white" />
              <span>{t('requested_exclamation')}</span>
            </div>
            <div className="modalSubTitle">{subTitle}</div>
          </ModalHeader>

          <Item
            icon={calendarIcon}
            name={t('date')}
            value={today.toLocaleDateString(local, localFormatOptions)}
          />
          <Item icon={priceIcon} name={t('total')} value={computedTotalPrice} />
          {isPaymentMethod && (
            <Item icon={walletIcon} name={t('payment_method')} value={t('credit_card')} />
          )}

          <Row>
            <ModalButton
              label={t('next')}
              iconRight="arrowNext"
              onClick={handleModalButton}
            />
          </Row>
          {/*Future the feature*/}
          {/*{isInvoice && (*/}
          {/*  <ModalSecondaryButton>{t('download_invoice')}</ModalSecondaryButton>*/}
          {/*)}*/}
        </ModalContent>
      </Modal>
    );
  },
);

export {PaidModal};
